module.exports = __webpack_public_path__ + "img/view-details.c317ba44.svg";